// extracted by mini-css-extract-plugin
export default {"wrapper":"e5-z","play":"f5-z"};